<template>
  <div>
    <b-modal :ref="id" :id="id" :title="$t('workspace.duplicate-option.title')" scrollable size="lg" title-class="font-18" v-model="show" @hidden="onHide">
      <div>
        <b-alert show variant="secondary">
          <span v-html="$t('workspace.duplicate-option.description', { workspace: workspace.name })"></span>
        </b-alert>

        <span v-html="$t('workspace.duplicate-option.copy-new-name', { workspace: workspace.name })" class="text-primary"></span>
        <sweet-input v-model="payload.newName" :isValid="!$v.payload.newName.$error" @input="$v.payload.newName.$touch()" type="text" layout="vertical" inputClass="mb-1" />
        <hr />

        <b-form-checkbox v-model="payload.copyMembers" switch class="mb-2"> {{ $t("workspace.duplicate-option.copy-members") }}</b-form-checkbox>
        <b-form-checkbox v-model="payload.copyLibrary" switch class="mb-3"> {{ $t("workspace.duplicate-option.copy-library") }}</b-form-checkbox>

        <sweet-button @click="duplicate()" :disabled="isDisabled" :loading="isUpdating" variant="primary" icon="bx bx-copy" :block="true">
          <span v-html="$t('workspace.duplicate-option.duplicate', { workspace: workspace.name })"></span>
        </sweet-button>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="show = false" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="ml-2">
            {{ $t("common.cancel") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { minLength, required } from "vuelidate/lib/validators";
export default {
  props: { id: { type: String, required: true }, workspace: { type: Object, required: true }, vuexStore: { required: false, default: "workspace" } },
  data() {
    return {
      payload: { newName: undefined, copyMembers: false, copyLibrary: false, sourceWorkspace: undefined },
      show: false,
    };
  },
  validations: {
    payload: {
      newName: {
        required,
        minLength: minLength(1),
      },
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters[`${this.vuexStore}/isLoading`];
    },
    isUpdating() {
      return this.$store.getters[`${this.vuexStore}/isUpdating`];
    },
    isDisabled() {
      return this.isLoading || this.$v.payload.newName.$error;
    },
  },
  mounted() {
    this.$v.$touch();
  },
  methods: {
    async duplicate() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        this.payload.sourceWorkspace = this.workspace;
        await this.$store.dispatch(`${this.vuexStore}/duplicate`, this.payload);

        location.reload();
        this.$toast.success("'" + this.$options.filters.translate(this.workspace.name) + "' " + this.$t("common.duplicate-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, {
          customMessage: "'" + this.$options.filters.translate(this.workspace.name) + "' " + this.$t("common.duplicate-fail"),
        });
      }
    },
    onHide() {
      this.payload = {};
      this.$emit("onHide");
    },
    onSuccess() {
      this.$emit("onSuccess");
    },
  },
};
</script>
